module.exports = __webpack_public_path__ + "static/img/khm.3d956ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/khm.svg
// module id = Gt+L
// module chunks = 0